import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ReferenceDao } from '@app/dao/reference/reference.dao';

@Component({
    selector: 'residences',
    templateUrl: './residences.component.html',
    styleUrls: ['./residences.component.scss'],
    standalone: false
})
export class ResidencesComponent implements OnInit, OnChanges {
  residencesForm: UntypedFormArray;

  @Input() derrors: any = undefined;
  countries: any[];
  reference$;

  constructor(
    private controlContainer: ControlContainer,
    private referenceDao: ReferenceDao,
  ) {}

  ngOnInit() {
    // this.cd.detectChanges();
    this.reference$ = this.referenceDao.getCountries();

    this.residencesForm = this.controlContainer.control as UntypedFormArray;
  }

  addFields() {
    this.residencesForm.markAsDirty();
    this.residencesForm.markAllAsTouched();

    if (this.residencesForm.valid) {
      this.residencesForm.push(
        new UntypedFormGroup({
          country: new UntypedFormControl('', Validators.required),
          nif: new UntypedFormControl('', Validators.required),
        }),
      );

      this.residencesForm.markAsUntouched();
      this.residencesForm.markAsDirty();
    } else {
      this.residencesForm.markAllAsTouched();
    }
  }

  deleteFields(index) {
    this.residencesForm.removeAt(index);

    this.residencesForm.markAsDirty();
    this.residencesForm.markAllAsTouched();
  }

  ngOnChanges() {
    if (this.residencesForm)
      this.residencesForm.controls.forEach(control => {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      });
  }
}
